import request from '@/axios'

/**
 * @Description: 获取全部问答信息
 */
export function selectAllQuestionsAnswersList(data){
  return request({
    method:'get',
    url:'/api/QuestionsAnswers/selectAllQuestionsAnswersList',
    params: data
  })
}
